import $ from 'jquery';

$(function () {
    const $variants = $('.app-variant-item');
    $variants.on('click', function (e) {
        e.preventDefault();
        $variants.removeClass('active');
        $(this).addClass('active');
        $('.app-variant-modifications').addClass('d-none');
        $('.app-variant-modifications-' + $(this).data('product-id')).removeClass('d-none');
    });

    $('.app-select-all-variants button').on('click', function (e) {
        e.preventDefault();
        if (parseInt($(this).data('sign'), 10) === 1) {
            $('.app-variant-modifications').not('.d-none').find('button[data-sign="1"]').trigger('click');
        } else {
            $('.app-variant-modifications').not('.d-none').find('button[data-sign="-1"]').trigger('click');
        }
    });
})
